import {SyntheticEvent} from 'react';

export function preventDefaultEvent(e: Event | SyntheticEvent) {
  e.preventDefault();
}
